import gql from 'graphql-tag'

export const absenceFragment = gql`
    fragment absenceFragment on Absence{
        id
        name
        date
        description
        rangeID
        absenceTypeID
    }
`

export const absenceTypeFragment = gql`
    fragment absenceTypeFragment on AbsenceType{
        id
        name
        label
        deleted_at
    }
`